<template>
  <div class="jzliu-bi-engine-middle-layer cdsp_dashboard" v-if="updateChartFlag" v-loading="chartData.loading" ref="middleLayerRef">
    <div class="jzliu-bi-engine-middle-layer-drag-handle" v-if="showActionMenu && !isDown">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <i class="el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="dataChartPreview" v-if="showChartPreview">预览图表数据</el-dropdown-item>
          <el-dropdown-item command="dwsPreview">预览明细数据</el-dropdown-item>
          <el-dropdown-item command="exportImg">导出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="jzliu-bi-engine-middle-layer-drill-handle" v-if="!showTitle && isHasDrill(chartData)">
      <img src="../../assets/img/drill2.png" alt="drill" width="13px" height="13px">
    </div>
    <div class="chart-header" v-if="showTitle">
      <span class="jzliu-bi-engine-title" v-if="chartData.styleConfig.commongConfig.showTitle">
        {{ chartData.name }}
      </span>
      <template v-if="chartData.styleConfig.commongConfig.showRemark">
        <el-tooltip v-if="chartData.styleConfig.commongConfig.remarkPosition === remarkPositionMap.title"
          :content="chartData.styleConfig.commongConfig.remark" placement="right">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </template>
      <el-tooltip v-if="isHasDrill(chartData) && !isDown" placement="right">
        <img style="position: relative;top: 2px;" src="../../assets/img/drill2.png" alt="drill" width="13px"
          height="13px">
        <div slot="content">
          <div>点击图表可下钻，钻取层级为：</div>
          <el-breadcrumb style="margin-top: 10px;" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in drillFieldsBreadcrumb">
              <span style="color: #fff;font-size: 12px;">{{ item }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-tooltip>
    </div>
    <div v-if="showRemark">
      <span class="remark">{{ chartData.styleConfig.commongConfig.remark }}</span>
    </div>
    <div class="chart-content" v-if="!isEmptyData"
      :style="{ height: showTitle ? (isShowDrill ? (showRemark ? 'calc(100% - 70px)':'calc(100% - 50px)') : (showRemark ? 'calc(100% - 50px)':'calc(100% - 30px)')) : (isShowDrill ? (showRemark ? 'calc(100% - 40px)' : 'calc(100% - 20px)') : showRemark ? 'calc(100% - 20px)' : 'calc(100%)') }">
      <component :chartConfigHandler="chartConfigHandler" :isShowDrill="isShowDrill" :is="computedTpl"
        :chartData="chartData" @table-page-change="handleTablePageChange" @drill-item-click="handleDrillItemClick"
        ref="computedTplRef">
      </component>
      <div v-if="isShowDrill" class="jzliu-bi-engine-middle-layer-drill-handle-content" style="height:20px;">
        <div class="jzliu-bi-engine-middle-layer-drill-handle-content-item">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in chartData.drillFields" :key="item.value">
              <span @click="onSpliceDrillField(index)" :title="item.label"
                :style="{ cursor: index <= (chartData.drillFields.length - 1) ? 'pointer' : 'default' }">{{ item.label
                }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </div>
    <div v-else class="jzliu-bi-engine-empty-data-container">
      <img src="../../assets/img/empty2.png" alt="empty">
      <div class="jzliu-bi-engine-empty-text">{{ chartData.isError ? '数据出错' : '暂无数据' }}</div>
    </div>
    <data-chart-preview ref="dataChartPreviewRef" :chartData="chartData" :direction="chartDirection"
      :mode="chartPreviewMode" @sort-change="handleSortChange" />
    <dws-preview ref="dwsPreviewRef" :chartData="chartData" :mode="previewMode" @sort-change="handleSortChange" />
  </div>
</template>

<script>
import defaultSeat from './defaultSeat'
import cTable from './cTable'
import cPie from './cPie'
import cColumn from './cColumn'
import chartRender from './chartRender'
import cIndicatorCard from './cIndicatorCard'
import { isHasDrill, remarkPositionMap } from '../../utils/panelConf'
import dwsPreview from '../base/preview/dwsPreview.vue'
import dataChartPreview from '../base/preview/dataChartPreview.vue'
import { defaultDrillField, defaultFilterField } from '../../utils/panelConf'
import { debounce } from 'lodash'
import { exportImage } from '@/utils'
export default {
  name: "middleLayer",
  components: { cPie, cTable, cColumn, chartRender, cIndicatorCard, defaultSeat, dwsPreview, dataChartPreview },
  props: {
    showActionMenu: {
      type: Boolean,
      default: true
    },
    dashboardName: {
      type: String,
      default: '',
    },
    chartDirection: {
      type: String,
      default: 'rtl'
    },
    isCustomDwsPreview: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'design'
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartConfigHandler: {
      type: Function,
      default: (conf) => conf,
    },
    previewMode: {
      type: String,
      default: 'drawer'
    },
    chartPreviewMode: {
      type: String,
      default: 'dialog'
    }
  },
  data() {
    return {
      remarkPositionMap,
      isHasDrill,
      updateChartFlag: true,
    }
  },
  created() {
    this.debouncedHandleDrillItemClick = debounce(this.handleDrillItemClickCore, 300)
  },
  computed: {
    isEmptyData() {
      return this.chartData?.data?.data?.length === 0 && this.chartData.status !== '-1'
    },
    isDown() {
      return this.chartData.status === '-1'
    },
    drillFieldsBreadcrumb() {
      return this.chartData.fields?.find(f => f.alias === 'drill')?.chooseFields?.map(item => item.name || item.unitName) ?? []
    },
    isShowDrill() {
      return this.chartData.drillFields?.length > 1 || this.drillFieldsBreadcrumb?.length === 1
    },
    isDesign() {
      return this.mode === 'design'
    },
    showTitle() {
      return this.chartData.styleConfig && (this.chartData.styleConfig.commongConfig.showTitle)
    },
    showRemark() {
      return this.chartData.styleConfig && this.chartData.styleConfig.commongConfig.showRemark && this.chartData.styleConfig.commongConfig.remarkPosition === remarkPositionMap.top
    },
    computedTpl() {
      if (!this.chartData.data) {
        return 'default-seat'
      }
      return 'chart-render'
    },
    showChartPreview() {
      return this.chartData.type !== 'Table'
    },
  },
  methods: {
    handleSortChange(column) {
      this.$emit('sort-change', column)
    },
    changeTitleShow(flag) {
      this.chartData.describeShow = flag
      this.$nextTick(() => {
        if (flag) {
          this.$refs.chartInput.focus()
        }
      })
    },
    handleTablePageChange(current, pageSize) {
      this.$emit('table-page-change', current, pageSize)
    },
    destroyedChart() {
      this.$refs.computedTplRef.destroyedChart()
    },
    handleExportImage() {
      exportImage(this,this.$refs.middleLayerRef,this.$refs.middleLayerRef,`${this.dashboardName}-${this.chartData.name}`,{backgroundColor: "#fff"})
    },
    handleCommand(command) {
      this.$emit('handle-table-command', command)
      if (command === 'dataChartPreview') {
        this.$refs.dataChartPreviewRef.open()
      } else if (command === 'dwsPreview' && !this.isCustomDwsPreview) {
        this.$refs.dwsPreviewRef.open()
      } else if (command === 'exportImg') {
        this.handleExportImage()
      }
    },
    handleDrillItemClick(data) {
      // 使用防抖函数
      this.debouncedHandleDrillItemClick(data)
    },
    handleDrillItemClickCore(data) {
      const drillFields = this.chartData.fields.find(f => f.alias === 'drill') || {}
      const chartData = data.data ?? data ?? {}
      let chooseFields = drillFields.chooseFields ?? []
      if (!chooseFields?.length) {
        return
      }
      const curIdx = this.chartData.drillFields.length
      const chooseField = chooseFields[curIdx]
      if (curIdx >= chooseFields.length) {
        this.$message.warning('已经钻取到最后一层了！')
        return
      }
      const key = chooseField.unitCode
      if (!this.chartData.drillFields.length) {
        this.$set(this.chartData.drillFields, 0, { label: chooseField.unitName, value: chooseFields[curIdx].unitCode, data: chartData })
        if (drillFields.chooseFields.length > 1) {
          this.$set(this.chartData.drillFields, curIdx + 1, { label: chartData[key], value: chooseFields[curIdx + 1].unitCode })
        }
      } else {
        this.chartData.drillFields[curIdx - 1].data = chartData
        this.$set(this.chartData.drillFields, curIdx, { label: chartData[chooseFields[curIdx - 1].unitCode], value: chooseFields[curIdx].unitCode })
      }
      this.$set(drillFields, 'drillFieldsBreadcrumb', this.chartData.drillFields)
      this.$emit('drill-item-click', { data, drillFields: this.chartData.drillFields })
      this.updateChartFlag = false
      this.$nextTick(() => {
        this.updateChartFlag = true
      })
    },
    updateSingleChart() {
      const drillFields = this.chartData.fields.find(f => f.alias === 'drill')
      this.$set(drillFields, 'drillFieldsBreadcrumb', [])
      this.$set(this.chartData, 'drillFields', [])
      this.$set(this.chartData, 'drillFields', [])
    },
    onSpliceDrillField(index) {
      this.chartData.drillFields.splice(index + 1, this.chartData.drillFields.length)
      this.$emit('drill-item-click', { data: {}, drillFields: this.chartData.drillFields })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-breadcrumb__inner {
  color: #2e74ff;
}

.jzliu-bi-engine-empty-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px;

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
  }
}

.jzliu-bi-engine-empty-text {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.jzliu-bi-engine-middle-layer {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;

  &:hover {
    .jzliu-bi-engine-middle-layer-drag-handle {
      visibility: visible;
    }

    .jzliu-bi-engine-middle-layer-drill-handle {
      visibility: visible;
    }
  }

  .jzliu-bi-engine-middle-layer-drag-handle {
    z-index: 9;
    visibility: hidden;
    cursor: pointer;
    width: 20px;
    height: 20px;
    position: absolute;
    top: -3px;
    right: 0;
    background: #fff;
    box-shadow: 0 0 4px rgba(0, 0, 0, .1);
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(90deg);
  }

  .chart-header {
    height: 20px;

    * {
      margin: 0;
      padding: 0;
    }

    .jzliu-bi-engine-title {
      color: #333;
      font-weight: bold;
    }
  }
}

.jzliu-bi-engine-middle-layer-drill-handle {
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 4px rgba(0, 0, 0, .1);
  visibility: hidden;
}

/deep/ .el-breadcrumb {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .el-breadcrumb__inner {
  max-width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  min-width: 12px;
  font-style: normal;
  display: inline-block;
  overflow: hidden;
}
</style>
